// extracted by css-extract-rspack-plugin
export default {"root":"ProjectTable_root__j15eV","headerRow":"ProjectTable_headerRow__s+Phr"};